import { render, staticRenderFns } from "./EditItemModal.vue?vue&type=template&id=4b0f3b56&scoped=true"
import script from "./EditItemModal.vue?vue&type=script&lang=js"
export * from "./EditItemModal.vue?vue&type=script&lang=js"
import style0 from "./EditItemModal.vue?vue&type=style&index=0&id=4b0f3b56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b0f3b56",
  null
  
)

export default component.exports